import { useCallback, useState } from "react";
import { useDefectAreaMaskStore } from "./useDefectAreaMaskStore";
import { useOverlayShortcuts } from "./useOverlayShortcuts";

// Shared visibility state for the ROI box and the context mask
export const useDefectAreaOverlay = (enabled = true) => {
  const { maskEnabled, toggleMask } = useDefectAreaMaskStore();
  const [roiEnabled, setRoiEnabled] = useState(true);
  // Hides all overlays while H is held
  const [isPeeking, setIsPeeking] = useState(false);
  useOverlayShortcuts(setIsPeeking, toggleMask, enabled);
  const toggleRoi = useCallback(() => setRoiEnabled((value) => !value), []);

  return {
    roiVisible: roiEnabled && !isPeeking,
    maskVisible: maskEnabled && !isPeeking,
    controls: {
      roiVisible: roiEnabled,
      maskVisible: maskEnabled,
      onRoiToggle: toggleRoi,
      onMaskToggle: toggleMask,
    },
  };
};
